
import BaseLayout from './BaseLayout.vue'
import { defineComponent } from 'vue'
import { loadingController } from "@ionic/vue"
import router from '../router'
import {userService} from "@/services/userService"
import {vedaService} from '@/services/vedaService'

// To test if a VEDA is connected to the internet, In other words, if the process is successful
// https://villageenergy.atlassian.net/browse/AD-704
// await fetch("https://cddevapi.village.energy/sat/v1/dvi/iot", {
//     "credentials": "include",
//     "headers": {
//         "Content-Type": "application/json",
//         "Authorization": "Bearer {accessToken}"
//     },
//     "body": "{\"satAction\":\"pingDevice\",\"deviceId\":\"b8f009907af8\",\"returnRecentStatusMsg\":true,\"debug\":true}",
//     "method": "PUT",
//     "mode": "cors"
// })

export default defineComponent ({
  name: 'CreateWifiAP',
  components: {
    BaseLayout
  },
  data: () => {
    return {
      ssid: '',
      password: ''
    }
  },
  created: function() {
    const details = vedaService.getVedaDetails()
    this.ssid = details.device.wifiSsid || details.device.defaultWifiSsid
    this.password = details.device.wifiPassword || details.device.defaultWifiPassword
  },
  methods: {
    async createWifiAp () {
      const loading = await loadingController
              .create({
                cssClass: 'my-custom-class',
                message: 'Please wait...',
                duration: 3000,
              })
      await loading.present()
      userService.createWifiAp({
        satAction: "pingDevice",
        deviceId: vedaService.getVedaDeviceId(),
        returnRecentStatusMsg: true,
        debug: vedaService.getDebug()
      }).then((response) => {
        console.log(response)
        if (response && response.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
          router.push('/create-wifi-ap-success')
        } else {
          // alert('VEDA not connected to the internet')
          userService.openToast('VEDA not connected to the internet', 'danger')
        }
        loading.dismiss()
      }, (err) => {
        // alert('Sorry! Could not connect to the Wi-Fi ap')
        userService.openToast('Sorry! Could not connect to the Wi-Fi ap', 'warning')
        console.log(err)
        loading.dismiss()
      })
    },
    handleSkip() {
      router.push('/offline-mode')
    }
  }
})
